// extracted by css-extract-rspack-plugin
export default {"IssueTypeToken":"IssueType-module__IssueTypeToken__H0zW5QU","hiddenPlaceholder":"IssueType-module__hiddenPlaceholder__P91B5Mn"};